import React, { createContext, useContext, useState } from "react";
import { SidebarProps } from "./types";

const SidebarContext = createContext({
  navSize: "large",
  setNavSize: (value: string) => {},
});

export const SidebarProvider = ({ children }: SidebarProps) => {
  const [navSize, setNavSize] = useState(() => {
    const savedSize = localStorage.getItem("navSize");
    return savedSize ? JSON.parse(savedSize) : "large";
  });

  return <SidebarContext.Provider value={{ navSize, setNavSize }}>{children}</SidebarContext.Provider>;
};

export const useSidebar = () => useContext(SidebarContext);
